const DEFAULT = { nombre: '' }

const reducer = (state = DEFAULT, action) => {
    switch(action.type) {
        default: 
            return state;
            
    }
}

export default reducer;